<div class="content-wrapper">
  @if (tableParams$ | async; as tableParams) {
    <markant-platform-ui-page-header class="headline">
      {{ 'organization.users.headline' | transloco }}

      <div actions class="user-actions">
        <markant-platform-table-column-select
          [tableColumns]="tableDraft.headerAndTableCells"
          [hiddenColumns]="tableParams.hiddenColumns ?? []"
          [defaultHiddenColumns]="DEFAULT_HIDDEN_COLUMNS"
          (columnsChange)="onColumnSelectionChange($event)"
        >
        </markant-platform-table-column-select>

        <markant-button
          colorScheme="primary"
          variant="clear"
          id="remove-user-button"
          data-cy="remove-user-button"
          (click)="openRemoveDialog()"
        >
          <markant-icon
            icon="m_user-remove"
            slot="icon-leading"
            class="icon"
          ></markant-icon>
          {{ 'organization.users.remove.action' | transloco }}
        </markant-button>
        <markant-button
          id="invite-user-button"
          data-cy="invite-user-button"
          colorScheme="primary"
          variant="clear"
          [disabled]="
            !organizationStatus || organizationStatus === 'DEACTIVATED'
          "
          (click)="openInviteDialog()"
        >
          <markant-icon
            icon="m_user-add"
            slot="icon-leading"
            class="icon"
          ></markant-icon>
          {{ 'organization.users.add' | transloco }}
        </markant-button>
      </div>
    </markant-platform-ui-page-header>

    <div class="toolbar">
      <markant-filter-group
        [clearText]="'common.clearAll' | transloco"
        [excludeSearchbar]="true"
        (filter)="onResetFilters($event.detail)"
      >
        <markant-searchbar
          placeholder="{{ 'organization.users.searchPlaceholder' | transloco }}"
          [value]="tableParams.searchQuery"
          [debounce]="300"
          (valueChange)="onSearchChange($event.detail)"
        >
        </markant-searchbar>

        @for (group of filter | keyvalue: keepOrder; track group.key) {
          <markant-filter-select
            data-cy="organization-member-overview-filter-select"
            [name]="group.key"
            [apply]="'common.apply' | transloco"
            [reset]="'common.reset' | transloco"
            [representation]="
              group.value.translationKey | defaultValue | transloco
            "
            [searchbar]="group.value.filterOptions.length > 6"
            [options]="
              group.value.searchedFilterOptions
                ? group.value.searchedFilterOptions
                : group.value.filterOptions
            "
            [appliedFilters]="tableParams.activeFilter[group.key] || []"
            (filterChange)="onFilterGroupChange($event.detail, group.key)"
            (searchbarValueChange)="
              onSearchbarValueChange($event.detail, group.value)
            "
          >
          </markant-filter-select>
        }

        <span slot="markant-filter-group-amount">
          {{ totalCount }}
          {{ 'organization.users.searchResultsFound' | transloco }}
        </span>
      </markant-filter-group>
    </div>

    <markant-platform-table
      [data]="tableData$ | async"
      [defaultHeaderCells]="tableDraft.headerAndTableCells"
      [loading]="(isLoading$ | async) ?? false"
      [totalCount]="totalCount"
      [pageSize]="tableParams.page.size"
      [pageIndex]="tableParams.page.index"
      (indexChanged)="onIndexChange($event)"
      (pageSizeChanged)="onPageSizeChange($event)"
      (selectionChanged)="onSelectionChange($event)"
      (sortChanged)="onSortChange($event)"
    >
    </markant-platform-table>
  }
</div>

<markant-platform-modal-bridge
  *ngIf="isInviteDialogOpen || isWarningUserDialogOpen"
>
  <markant-platform-organization-member-invitation
    *ngIf="isInviteDialogOpen"
    [organizationId]="organizationId"
    [organizationQualificationLevel]="organizationQualificationLevel"
    (closedWithReload)="invitationDialogClosed($event)"
  ></markant-platform-organization-member-invitation>

  <markant-platform-info-dialog
    *ngIf="isWarningUserDialogOpen"
    [headline]="'organization.users.warningTitle' | transloco"
    [text]="'organization.users.warningLabel' | transloco"
    [buttonText]="'general.close' | transloco"
    (openChange)="closeWarningUserDialog()"
    (submitChange)="closeWarningUserDialog()"
  >
  </markant-platform-info-dialog>
</markant-platform-modal-bridge>

<markant-platform-organization-member-remove-user-dialog
  *ngIf="isRemoveDialogOpen"
  [organizationId]="organizationId!"
  [users]="usersToRemove"
  [open]="isRemoveDialogOpen"
  (closeChanged)="closeRemoveDialogOpen()"
  (removalCompleted)="clearAndReload()"
></markant-platform-organization-member-remove-user-dialog>
